module.exports = __webpack_public_path__ + "img/f-tl.c90f1852.png";